<div *ngIf="isCheckingAuth" class="check-auth-spinner-container">
  <onep-spinner></onep-spinner>
</div>
